import { render } from "./CalendarCreate.vue?vue&type=template&id=12310d0e"
import script from "./CalendarCreate.vue?vue&type=script&lang=js"
export * from "./CalendarCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__